import { useTranslation } from 'react-i18next'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'
import { RoutePath } from '../layout/Routes'

import { DonationListTable } from './DonationListTable/DonationListTable'
import { Grid } from '@percent/lemonade'
import { useRequiredParams } from '@percent/partner-dashboard/common/hooks'

export function DonationContainer({ fundraiserName }: { fundraiserName?: string }) {
  const { t } = useTranslation()
  const { fundraiserId } = useRequiredParams()

  useBreadcrumbs(
    fundraiserId
      ? [
          {
            label: t('breadcrumb.fundraisers'),
            path: RoutePath.WORKPLACE_GIVING_FUNDRAISERS
          },
          {
            label: fundraiserName || fundraiserId
          }
        ]
      : [
          {
            label: t('breadcrumb.donations')
          }
        ]
  )

  return (
    <Grid>
      <Grid.Col>
        <DonationListTable />
      </Grid.Col>
    </Grid>
  )
}
